export default function headerScroll() {
	return {
		isHome: document.body.classList.contains( 'home' ),
		scrollProgress: 0,
		heroElement: null,

		init() {
			if ( this.isHome ) {
				this.setupScrollTracking();
			}
		},

		getHomeHeaderStyle( progress ) {
			// Multi-step transition for smooth visual flow
			if ( progress === 0 ) {
				// Step 1: Starting state - black to transparent (vertical)
				return 'background: linear-gradient(to bottom, oklch(0 0 0 / 70%), oklch(0 0 0 / 0%))';
			}

			if ( progress <= 0.5 ) {
				// Step 2: Morph top color from black to navy (keep vertical)
				const step1Progress = progress / 0.5;
				const topColor =
					step1Progress < 1
						? `oklch(${ 0.3656 * step1Progress } ${
								0.1025 * step1Progress
						  } ${ 255.79 * step1Progress } / 70%)`
						: 'oklch(0.3656 0.1025 255.79 / 70%)';
				return `background: linear-gradient(to bottom, ${ topColor }, oklch(0 0 0 / 0%))`;
			}

			// Step 3: Add blue bottom, keep vertical - reach full opacity
			const step2Progress = ( progress - 0.5 ) / 0.5;
			const navyAlpha = 0.7 + 0.3 * step2Progress; // 0.7 to 1.0
			const blueAlpha = step2Progress; // 0 to 1.0 for full opacity
			return `background: linear-gradient(to bottom, 
				oklch(0.3656 0.1025 255.79 / ${ navyAlpha }), 
				oklch(0.6044 0.1117 251.23 / ${ blueAlpha }))`;
		},

		setupScrollTracking() {
			this.heroElement = document.querySelector( '.hero' );
			if ( ! this.heroElement ) return;

			// Use RAF for smooth updates
			let ticking = false;

			const updateScrollProgress = () => {
				const heroRect = this.heroElement.getBoundingClientRect();
				const viewportCenter = window.innerHeight / 2;
				const heroBottom = heroRect.bottom;

				// Start transition when hero bottom hits viewport center
				if ( heroBottom > viewportCenter ) {
					this.scrollProgress = 0;
				} else {
					// Calculate progress based on how far past center we are
					const heroHeight = this.heroElement.offsetHeight;
					const progressDistance = heroHeight * 0.35; // Faster transition - 50% of hero height
					const scrolledPastCenter = viewportCenter - heroBottom;
					this.scrollProgress = Math.min(
						scrolledPastCenter / progressDistance,
						1
					);
				}

				ticking = false;
			};

			const onScroll = () => {
				if ( ! ticking ) {
					requestAnimationFrame( updateScrollProgress );
					ticking = true;
				}
			};

			window.addEventListener( 'scroll', onScroll, { passive: true } );

			// Initial calculation
			updateScrollProgress();
		},
	};
}
